import { Button, Card, Flex, Space } from "antd";
import { useTranslation } from "react-i18next";

const SettingProjectWorkflow = ({
    RenderCell = () => { },
    HandleSave = () => { },
    onCancelWorkflow = () => { },
    list = []
}) => {
    const { t } = useTranslation();

    return (
        <Card
            style={{
                backgroundColor: "white",
                width: "100%",
                boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.15)',
                borderRadius: "20px"
            }}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <h3>{t("workflow.header")}</h3>
                    <span style={{ color: "#667085" }}>{t("workflow.label.detail")}</span>
                </Flex>

                <Flex
                    vertical
                    style={{
                        overflowX: "auto",
                        paddingTop: "1vw",
                        paddingBottom: "2vw",
                        width: "100%",
                        flexGrow: 1,
                        minWidth: "100%",
                    }}
                >
                    <Flex
                        gap={40}
                        style={{
                            width: "100%",
                            minWidth: "max-content",
                            justifyContent: "flex-start",
                        }}
                    >
                        {RenderCell()}
                    </Flex>
                </Flex>

                <Flex gap={12} justify="end" style={{
                    display: list?.filter?.(o => o.isEdit)?.length ? "flex" : "none"
                }}>
                    <Button type="default"
                        style={{ height: "40px", borderRadius: "8px", color: "#565656" }}
                        onClick={() => { onCancelWorkflow() }}
                    >
                        {t("common.cancel").toUpperCase()}
                    </Button>

                    <Button
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white" }}
                        onClick={() => { HandleSave() }}
                    >
                        {t("common.submit").toUpperCase()}
                    </Button>
                </Flex>
            </Space>
        </Card>
    )
}

export default SettingProjectWorkflow;